import '../styles/variables.scss';

const SERVICE_DETAILS = 'Service Detail:';
const BRAND_BLUE_COLOR_CLASS = 'brand-blue-color';
const BRAND_BLUE_DARK_CLASS = 'brand-blue-dark';
const GREY_LIGHT_CLASS = 'grey-light';
const SERVICE_TIME = 'Service Time:';

export const tradeDetails = [
  {
    code: 'FLIGHT',
    serviceDetails: {
      title: SERVICE_DETAILS,
      data: 'Flight No',
      example: '(e.g. AF 111)',
      titleClassName: BRAND_BLUE_COLOR_CLASS,
      dataClassName: BRAND_BLUE_DARK_CLASS,
      exampleClassName: GREY_LIGHT_CLASS
    },
    serviceTime: {
      title: SERVICE_TIME,
      data: 'Take-off Time',
      example: '(e.g. 2018-04-01 23:20~2018-04-02 05:40)',
      titleClassName: BRAND_BLUE_COLOR_CLASS,
      dataClassName: BRAND_BLUE_DARK_CLASS,
      exampleClassName: GREY_LIGHT_CLASS
    }
  },
  {
    code: 'HOTEL_ACCOMODATION',
    serviceDetails: {
      title: SERVICE_DETAILS,
      data: 'Hotel Name',
      example: '(e.g. Hilton Garden Inn Waikiki Beach)',
      titleClassName: BRAND_BLUE_COLOR_CLASS,
      dataClassName: BRAND_BLUE_DARK_CLASS,
      exampleClassName: GREY_LIGHT_CLASS
    },
    serviceTime: {
      title: SERVICE_TIME,
      data: 'Check-in Time',
      example: '(e.g. 2018-04-01~2018-04-02)',
      titleClassName: BRAND_BLUE_COLOR_CLASS,
      dataClassName: BRAND_BLUE_DARK_CLASS,
      exampleClassName: GREY_LIGHT_CLASS
    }
  },
  {
    code: 'TRAVEL',
    serviceDetails: {
      title: SERVICE_DETAILS,
      data: 'Destination',
      example: 'e.g. Hongkong',
      titleClassName: BRAND_BLUE_COLOR_CLASS,
      dataClassName: BRAND_BLUE_DARK_CLASS,
      exampleClassName: GREY_LIGHT_CLASS
    },
    serviceTime: {
      title: SERVICE_TIME,
      data: 'Starting Time',
      example: 'e.g. 2018-04-01',
      titleClassName: BRAND_BLUE_COLOR_CLASS,
      dataClassName: BRAND_BLUE_DARK_CLASS,
      exampleClassName: GREY_LIGHT_CLASS
    }
  },
  {
    code: 'OVERSEAS_STUDY',
    serviceDetails: {
      title: SERVICE_DETAILS,
      data: 'Name of University/School',
      example: '(e.g. University of Cambridge)',
      titleClassName: BRAND_BLUE_COLOR_CLASS,
      dataClassName: BRAND_BLUE_DARK_CLASS,
      exampleClassName: GREY_LIGHT_CLASS
    },
    serviceTime: {
      title: SERVICE_TIME,
      data: ' Enrollment Date',
      example: '(e.g. 2018-04-01)',
      titleClassName: BRAND_BLUE_COLOR_CLASS,
      dataClassName: BRAND_BLUE_DARK_CLASS,
      exampleClassName: GREY_LIGHT_CLASS
    }
  },
  {
    code: 'OTHERS',
    serviceDetails: {
      example: '(In accordance with the service information as presented in the order or contract)',
      exampleClassName: GREY_LIGHT_CLASS
    },
    serviceTime: {
      example: '(In accordance with the service information as presented in the order or contract)',
      titleClassName: BRAND_BLUE_COLOR_CLASS,
      dataClassName: BRAND_BLUE_DARK_CLASS,
      exampleClassName: GREY_LIGHT_CLASS
    }
  }
];
